export const border_radius = {
  /** (0px) */ none: "0",
  /** (2px) */ rounded_xs: "var(--radius-rounded-xs)",
  /** (4px) */ rounded_sm: "var(--radius-rounded-sm)",
  /** (8px) */ rounded_md: "var(--radius-rounded-md)",
  /** (12px) */ rounded_lg: "var(--radius-rounded-lg)",
  /** (16px) */ rounded_xl: "var(--radius-rounded-xl)",
  /** (24px) */ rounded_xxl: "var(--radius-rounded-xl)",
  /** (32px) */ rounded_xxxl: "var(--radius-rounded-xxl)",
  /** (9999px) */ rounded_full: "var(--radius-rounded-full)",
} as const;
/**
 * border-radius: ${border_radius.rounded_sm};
 */
